import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';

/** Renders a reusable checkbox option with card-click support and nested control isolation. */
const CheckboxOption = ({ label, description, checked, onChange, disabled = false, className = '', selectedClassName = '', children }) => {
    /** Toggles the checkbox when the card background is clicked. */
    const handleCardClick = () => {
        if (!disabled) onChange({ target: { checked: !checked } });
    };

    /** Prevents nested controls from triggering the card click handler. */
    const stopCardClick = (event) => event.stopPropagation();

    const optionClassName = `${className}${checked && selectedClassName ? ` ${selectedClassName}` : ''}`.trim();

    return (
        <div className={optionClassName} onClick={handleCardClick}>
            <FormControlLabel
                disabled={disabled}
                control={<Checkbox checked={checked} onChange={onChange} />}
                onClick={stopCardClick}
                style={description ? { alignItems: 'flex-start' } : {}}
                label={
                    <span style={{ display: 'inline-block', paddingTop: description ? '10px' : '0px' }}>
                        <span className="restorative-option-label">{label}</span>
                        {description && <span className="restorative-option-description">{description}</span>}
                    </span>
                }
            />
            {children && <div onClick={stopCardClick}>{children}</div>}
        </div>
    );
};

export default CheckboxOption;
